"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DetailRequest = void 0;
var DetailRequest = /** @class */ (function () {
    function DetailRequest() {
    }
    return DetailRequest;
}());
exports.DetailRequest = DetailRequest;
;
//# sourceMappingURL=detail.request.js.map